// MT-050 — módulo (pantalla) desde el que sale una petición FHIR. Viaja en la cabecera `X-LC-Modulo` y el proxy del servidor lo anota en la bitácora
// de acceso. Es un dato de CONTEXTO (el navegador lo declara): la bitácora no depende de él para saber quién y qué paciente; solo sirve para
// responder «desde qué pantalla».
const BASENAME = '/hce/paciente';

/** Un segmento que parece un id (uuid, número largo, hash): se descarta para que la etiqueta sea el módulo y no el paciente. */
function pareceId(segmento: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-/i.test(segmento) || /^\d{6,}$/.test(segmento) || /^[0-9a-z]{20,}$/i.test(segmento);
}

/** `/hce/paciente/paciente/<uuid>/historia` → `paciente/historia`; `/hce/paciente/dashboard` → `dashboard`; sin ruta → `inicio`. Máx. 3 segmentos, 60 caracteres. */
export function moduloDeRuta(pathname: string): string {
  let ruta = pathname.split('?')[0]?.split('#')[0] ?? '';
  while (ruta.startsWith(BASENAME)) ruta = ruta.slice(BASENAME.length);
  const segmentos = ruta
    .split('/')
    .map((s) => s.trim().toLowerCase())
    .filter((s) => s !== '' && !pareceId(s) && /^[a-z0-9][a-z0-9_-]*$/.test(s));
  const etiqueta = segmentos.slice(0, 3).join('/').slice(0, 60);
  return etiqueta || 'inicio';
}

export function moduloActual(): string {
  try {
    return moduloDeRuta(window.location.pathname);
  } catch {
    return 'desconocido';
  }
}
